// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pin';

export const Component = () => (
  <>
    <path d='M11.638 2.347V0L0 11.686h2.347l10.488 10.488v2.347l4.694-4.645 6.992 4.645-4.645-6.992 4.645-4.694h-2.347L11.637 2.347h.001Zm-9.291 8.381 8.333-8.333v.382l.288.288 10.488 10.44.288.288h.431l-3.017 3.017-.527.575.431.67 1.964 2.97-2.97-1.963-.67-.432-.575.527-3.017 3.017v-.431l-.288-.288-10.44-10.44-.288-.288h-.431v.001Z' />
    <path d='m19.492 10.153-9.339 9.34-.67-.671 9.339-9.34.67.671Z' />
  </>
);

export const viewBox = '0 0 25 25';
